module.exports = __webpack_public_path__ + "static/media/Github.f2912f31.svg";